import config from "@/utils/Config";
import {get, post } from "@/utils/request";

export function getLocalPosition(params = {}) {
    return get(config.BASE_URL, config.getPositionUrl, params)
}

export function getWeather(params = { cityCode: cityCode }) {
    return get(config.BASE_URL, config.getWeatherUrl, params)
}